// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-08a92bb0]{min-height:100vh;display:flex;flex-direction:column;--padding-top:56px}@media(max-width:1050px){.content[data-v-08a92bb0]{--padding-top:105px}}", ""]);
// Exports
module.exports = exports;
